import { Box } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { Check, X } from 'lucide-react';
import { useIntl } from 'react-intl';
import { QuietButton } from '~/containers/patient-list/shared';
import { QUEUE_STATE_COLOR, statusStripSx } from './importStatus';

/** Read-only status strip shown when a queue entry has already been imported or skipped. */
export default function ResolvedBanner({
    kind,
    text,
    onUndo,
}: {
    kind: 'imported' | 'skipped';
    text: string;
    onUndo?: () => void;
}) {
    const intl = useIntl();
    const imported = kind === 'imported';
    return (
        <Box
            sx={[
                statusStripSx,
                {
                    fontSize: 13,
                    color: QUEUE_STATE_COLOR[kind],
                    bgcolor: (theme) =>
                        alpha(
                            imported
                                ? theme.palette.success.main
                                : theme.palette.warning.main,
                            0.09
                        ),
                },
            ]}
        >
            {imported ? <Check size={15} /> : <X size={15} />}
            {text}
            {onUndo && (
                <>
                    <Box sx={{ flex: 1 }} />
                    <QuietButton onClick={onUndo}>
                        {intl.formatMessage({
                            id: 'patientList.import.review.undo',
                        })}
                    </QuietButton>
                </>
            )}
        </Box>
    );
}
